module.exports = __webpack_public_path__ + "static/img/button-1.6ec51d06.jpeg";